const state = {
  show: false,
  taxiId: undefined,
  actionChecked: 1,
};

const mutations = {
  TOGGLE_REUBICAR_EXPULSAR_DIALOG: (state, payload) => {
    state.show = payload.show;
    state.taxiId = payload.taxiId;
    state.actionChecked = payload.actionChecked;
  },

  RESET_DIALOG: (state) => {
    state.taxiId = undefined;
    state.actionChecked = 1;
  },

  SET_ACTION_CHECKED: (state, actionChecked) => {
    state.actionChecked = actionChecked;
  },
};

const actions = {
  showDialog({ commit }, payload) {
    commit("TOGGLE_REUBICAR_EXPULSAR_DIALOG", payload);
    if (!payload.show) commit("RESET_DIALOG");
  },
  setActionChecked({ commit }, actionChecked) {
    commit("SET_ACTION_CHECKED", actionChecked);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
